// removed by extract-text-webpack-plugin
module.exports = {"box":"_2Ytju__MFs8rJzbnSPYrIN","group":"_3rGy8cgX93pgddsd8jRm_u","icon":"_2Kcl0jglmn_DbSoqgOx8IZ","content":"_9OZN3kMIyLxMZIzNf3xTm","inputCode":"_1I-5hUXEzpAlEhvlf0vmRD","valid":"_1q0kGPaEuPVN7A43Q6Yf7l","invalid":"_1zVMsbkeQcH7YHmmEj2buG","btnRemove":"_7IkDZIghwyaxT9jhAfCag"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/CodeCard.scss
// module id = 1103
// module chunks = 0